export default {
  cookieExpires: 1,
  useFingerPrint: true,
  mobAppActiveGroup: 9241, //# golomt
  appForce: 0,

  ////gosmart server
  //hubBaseUrl: 'https://mobcoreapi.gosmart.mn/',
  hubBaseUrl: '',
  resBaseUrl: '',

  lmsPages: [
    'lmsWelcome', 'lmsParticipant', 'lmsCourses', 'lmsCourseView', 'lmsLessonView', 'lmsAttend', 'lmsCalendar', 'lmsCalendarTeacher', 'lmsLibrary',
    'lmsDashboard', 'lmsNotif', 'lmsPaymentDetail', 'lmsPaymentList', 'lmsEventDetail', 'lmsEventList',
    'lmsMembership', 'lmsMembershipEthic', 'lmsMembershipOrg', 'lmsMembershipPayment',
    'lmsResearchList', 'lmsNewsList', 'lmsMagazineList', 'lmsLegalList', 'lmsAuditLicenseRequest', , 'lmsFeedback', 'lmsOffline',

    //# TODO admin yed hamaarahgui
    'userProfile',
  ],

  mobApps: [
    {
      id: 9241,
      key: 'FUCYnR1jOEqpd_SfjmPWOw',
      name: "For Developers",
      logo: "media/logo/onoo.png",
      bgLogin: "assets/img/covid.svg",
      hostPro: ['dev.gosmart.mn'],
      hostDev: ['192.168.0.105:80809', '192.168.42.2:8087', '192.168.0.100:8080s'],
      fileUploadSize: {
        default: {
          size: 1048576,
          msg: "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 1гб байна."
        },
        student: {
          size: 30720,
          msg: "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 30мб байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      register: true,
      helpPageUrl: "http://help.gosmart.mn",
      streamBaseUrl: 'https://stream-gate.gosmart.mn/',
      baseUrl: 'https://devapi.gosmart.mn/',
    },{
      // id: 9241,
      // key: 'FUCYnR1jOEqpd_SfjmPWOw',
      id: 9249,
      key: 'k1P0nf1qAkGwRXB6L4Q8_Q',
      name: "Голомт Академи",
      logo: "media/logo/golomt.png",
      logoFooter: "assets/img/golomt/logo-footer.png",
      skin: 'is-golomt',
      publicPage: {
        has: true,
        route: 'landingPage'
      },
      learnConfig: {
        course: {
          showAlert: false
        }
      },
      hostPro: ['academy.golomtbank.local', 'academy.golomtbank.com', 'lmsuat.golomtbank.local', 'lmsdemo.gosmart.mn', 'golomt.gosmart.mn', 'sandboxgolomt.gosmart.mn', '192.168.205.46', '192.168.1.82'],
      hostDev: ['192.168.0.105:80808', '192.168.0.100:80801', '192.168.42.173:8080', '192.168.1.10:8080'],
      register: true,
      fileUploadSize: {
        default: {
          size: 1048576,
          msg: "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 1гб байна."
        },
        student: {
          size: 204800,
          msg: "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 200мб байна."
        }
      },
      helpPageUrl: "https://lms-help.golomtbank.local",

      // streamBaseUrl: 'https://lms-stream.golomtbank.local:8443/',
      // reportBaseUrl: 'https://lms-doc.golomtbank.local/',
      // PDFJS_URL: 'https://lms-cdn.golomtbank.local/static/pdfobject/web/viewer.html',
      // cdnBaseUrl: 'https://lms-cdn.golomtbank.local/',  
      // hubBaseUrl: 'https://lms-stream.golomtbank.local/',
      // baseUrl: 'https://academy.golomtbank.local/core/',
      // resBaseUrl: 'https://lms-cdn.golomtbank.local/',  

      streamBaseUrl: 'https://lms-stream.golomtbank.com:8443/',
      reportBaseUrl: 'https://lms-doc.golomtbank.com/',
      PDFJS_URL: 'https://lms-cdn.golomtbank.com/static/pdfobject/web/viewer.html',
      cdnBaseUrl: 'https://lms-cdn.golomtbank.com/',  
      hubBaseUrl: 'https://lms-stream.golomtbank.com/',
      baseUrl: 'https://academy.golomtbank.com/core/',
      resBaseUrl: 'https://lms-cdn.golomtbank.com/',  
    },
    {
      id: 98,
      name: "Гөү смарт ТМ ХХК",
      key: 'zIGhSWMcrLTeOUvByGtMr1',
      logo: "media/icon.png",
      skin: '',
      publicPage: {
        //has: false,
        has: true,
        route: 'landingHelp'
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      hostPro: ['help.gosmart.mn', 'v3.gosmart.mn', '192.168.205.46:7050', 'lmsuat.golomtbank.local:5050'],
      hostDev: ['192.168.0.105:80802', '192.168.42.2:80808', '192.168.0.100:80801', '192.168.1.5:80803'],
      fileUploadSize: {
        default: {
          size: 204800,
          msg: "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 200мб байна."
        },
        student: {
          size: 102400,
          msg: "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100мб байна."
        }
      },
      helpPageUrl: "http://help.gosmart.mn",
      streamBaseUrl: 'https://stream-gate.gosmart.mn/',
    },
    {
      id: 9157,
      name: "ММНБИ",
      key: 'iN2VmYTU1OS0xMTViLTxzc',
      logo: "media/logo/monicpa_mini.jpg",
      bgLogin: "assets/img/monicpa.jpg",
      hostPro: ['dynamic.monicpa.mn', 'monicpa.gosmart.mn'],
      hostDev: ['192.168.0.105:8080', '192.168.0.100:80809', '192.168.1.2:8081', '192.168.42.2:8089', '192.168.0.169:8080'],
      fileUploadSize: {
        default: {
          size: 1536000,
          msg: "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 1.5GB байна."
        },
        student: {
          size: 30720,
          msg: "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 30мб байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      register: true,
      helpPageUrl: "http://help.gosmart.mn",
      v2BaseUrl: "http://office.monicpa.mn",
      streamBaseUrl: 'https://stream-gate.gosmart.mn/',
      hubBaseUrl: 'https://dynamic.monicpa.mn/core/',
      baseUrl: 'https://dynamic.monicpa.mn/mobcore/',
    },
    {
      id: 6126,
      name: "МУТМЗН",
      key: 'JOI7zQxTsAZZXS21cEbaPq',
      logo: "media/logo/tmz.png",
      bgLogin: "assets/img/img15.png",
      hostPro: ['members.cpta.mn', 'cpta.gosmart.mn'],
      hostDev: ['192.168.0.105:80801', '192.168.42.2:8089'],
      publicPage: {
        has: true,
        route: 'landingPage'
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      fileUploadSize: {
        default: {
          size: 1536000,
          msg: "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 1.5GB байна."
        },
        student: {
          size: 30720,
          msg: "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 30мб байна."
        }
      },
      register: true,
      helpPageUrl: "http://help.gosmart.mn",
      streamBaseUrl: 'https://stream-gate.gosmart.mn/',
      hubBaseUrl: 'https://app.gosmart.mn/coreTMZ/',
      baseUrl: 'https://members.cpta.mn/mobcore/',
    },
    {
      id: 9161,
      key: 'cAtbPfwB2VFwAMX3lm1Z0H',
      name: "ММҮИ",
      logo: "media/logo/mica.jpg",
      skin: '',
      publicPage: {
        has: false,
        route: 'landingPage'
      },
      learnConfig: {
        course: {
          showAlert: false
        }
      },
      hostPro: ['v3.mica.gosmart.mn'],
      hostDev: ['192.168.0.105:80801', '192.168.0.100:80803', '192.168.42.2:80803', '192.168.1.5:80803'],
      register: true,
      fileUploadSize: {
        default: {
          size: 1536000,
          msg: "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 1.5GB байна."
        },
        student: {
          size: 30720,
          msg: "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 200мб байна."
        }
      },
      helpPageUrl: "https://lms-help.golomtbank.local",
      streamBaseUrl: 'https://stream-gate.gosmart.mn/',
    },
    {
      id: 9166,
      name: "Номин холдинг",
      key: 'a_qkflbHjU_np4KIz_eImP',
      logo: "media/logo/nomin.jpg",
      bgLogin: "assets/img/img15.png",
      hostPro: ['nomin.gosmart.mn'],
      hostDev: ['192.168.0.105:80820', '192.168.42.2:80809'],
      fileUploadSize: {
        default: {
          size: 1536000,
          msg: "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 1.5GB байна."
        },
        student: {
          size: 30720,
          msg: "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 30мб байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      register: false,
      helpPageUrl: "http://help.gosmart.mn",
      streamBaseUrl: 'https://stream-gate.gosmart.mn/',
      hubBaseUrl: 'https://nomin.gosmart.mn/core/',
      baseUrl: 'https://nomin.gosmart.mn/mobcore/',
    },
    {
      id: 9226,
      name: "Moore Audit",
      key: 'N0lyUq26NkeOPob6u8unmg',
      logo: "media/logo/moore.png",
      bgLogin: "assets/img/img15.png",
      hostPro: ['mooreaudit.gosmart.mn'],
      hostDev: ['192.168.42.2:80809'],
      fileUploadSize: {
        default: {
          size: 1536000,
          msg: "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 1.5GB байна."
        },
        student: {
          size: 30720,
          msg: "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 30мб байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      register: true,
      helpPageUrl: "http://help.gosmart.mn",
      streamBaseUrl: 'https://stream-gate.gosmart.mn/',
    },
    {
      id: 9231,
      name: "BizGuide",
      key: 'dQXUXRo_zE6OJ6kXSw0_OA',
      skin: 'is-bizguide',
      publicPage: {
        has: true,
        route: 'landingPage'
      },
      logo: "media/logo/bizguide.png",
      logoFooter: "assets/img/bizguide/logo-footer.png",
      bgLogin: "assets/img/img15.png",
      hostPro: ['learning.bizguide.mn', 'learning.bizguide.mn'],
      hostDev: ['192.168.0.105:8081'],
      fileUploadSize: {
        default: {
          size: 1536000,
          msg: "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 1.5GB байна."
        },
        student: {
          size: 30720,
          msg: "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 30мб байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      register: true,
      helpPageUrl: "http://help.gosmart.mn",
      streamBaseUrl: 'https://stream-gate.gosmart.mn/',
    },
    {
      id: 9234,
      name: "Шинэ эхлэл - Хөгжлийн ирээдүй ТББ",
      key: 'xlM9EBJS4UOJholOygbWyw',
      logo: "media/logo/eboard.png",
      bgLogin: "assets/img/img15.png",
      hostPro: ['eboard.gosmart.mn'],
      hostDev: ['192.168.42.2:80809'],
      fileUploadSize: {
        default: {
          size: 1536000,
          msg: "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 1.5GB байна."
        },
        student: {
          size: 30720,
          msg: "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 30мб байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      register: true,
      helpPageUrl: "http://help.gosmart.mn",
      streamBaseUrl: 'https://stream-gate.gosmart.mn/',
    },
    {
      id: 9162,
      name: "Бичил глобус",
      key: 'bANNURFrgQOmLOrt8DHpTi',
      logo: "media/logo/bichil.png",
      bgLogin: "assets/img/img15.png",
      hostPro: ['bg.gosmart.mn'],
      hostDev: ['192.168.42.2:80809'],
      fileUploadSize: {
        default: {
          size: 1536000,
          msg: "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 1.5GB байна."
        },
        student: {
          size: 30720,
          msg: "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 30мб байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      register: true,
      helpPageUrl: "http://help.gosmart.mn",
      streamBaseUrl: 'https://stream-gate.gosmart.mn/',
    },
    {
      id: 9240,
      name: "Архивын Ерөнхий газар",
      key: 'GYwwpUowV0uPVAOtqg2vcA',
      logo: "media/logo/archives.png",
      bgLogin: "assets/img/img15.png",
      hostPro: ['archives.gosmart.mn'],
      hostDev: ['192.168.0.105:80801', '192.168.42.2:80809'],
      fileUploadSize: {
        default: {
          size: 1536000,
          msg: "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 1.5GB байна."
        },
        student: {
          size: 30720,
          msg: "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 30мб байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      register: true,
      helpPageUrl: "http://help.gosmart.mn",
      streamBaseUrl: 'https://stream-gate.gosmart.mn/',
    },
    {
      id: 1104,
      //name: "Төрийн албаны цахим сургалт",
      //logo: "media/logo/soyombo.png",
      //name: "Динамик Цахим сургалтын платформ",
      name: "Цахим сургалт",
      //logo: "media/logo/onoo.png",
      logo: "media/logo/soyombo.png",
      bgLogin: "assets/img/covid.svg",
      skin: 'gov',
      key: 'oXSBUpThuoeNxcra7HH3Em',
      hostPro: ['demo.gosmart.mn', 'learning.bizguide.mn', 'lms.onoo.mn', 'new.onoo.mn'],
      hostDev: ['192.168.0.105:80802', '192.168.42.2:8087', '192.168.0.100:8080s'],
      fileUploadSize: {
        default: {
          size: 1048576,
          msg: "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 1гб байна."
        },
        student: {
          size: 30720,
          msg: "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 30мб байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      register: true,
      helpPageUrl: "http://help.gosmart.mn",
      streamBaseUrl: 'https://stream-gate.gosmart.mn/',
    },
    {
      id: 9233,
      name: "vet.med",
      key: 'HMk8BCDrIEe1hxj6f6JQyA',

      hasHomePage: true,
      defaultHome: 'vet-med',
      helpPageUrl: "http://help.gosmart.mn",
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      streamBaseUrl: 'https://stream-gate.gosmart.mn/',
    },
    {
      id: 9237,
      name: "asset.ubtraffic",
      key: 'o_usZfT6uEqqyNdRP5vVpg',
      helpPageUrl: "http://help.gosmart.mn",
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      logo: "media/logo/ubtraffic.png",
      logoFooter: "assets/img/ubtraffic/logo-footer.png",
      skin: '',
      publicPage: {
        has: false,
        route: 'landingPage'
      },
      hostPro: ['asset.gosmart.mn'],
      hostDev: ['192.168.0.105:80801', '192.168.0.105:8081', '192.168.0.100:8080', '192.168.42.2:8081', '192.168.1.5:80809'],
      register: true,
      fileUploadSize: {
        default: {
          size: 1048576,
          msg: "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 1гб байна."
        },
        student: {
          size: 204800,
          msg: "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 200мб байна."
        }
      },

      streamBaseUrl: 'https://stream-gate.gosmart.mn/',
    },
    {
      id: 9238,
      name: "zhut.report",
      key: 'U1ZjGhgPIE_unNxET2TYwQ',
      helpPageUrl: "http://help.gosmart.mn",
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      streamBaseUrl: 'https://stream-gate.gosmart.mn/',
    },
    {
      id: 9250,
      key: 'KFCTQHTYZESz0hBJnqclzQ',
      name: "Голомт Академи",
      logo: "media/logo/golomt.png",
      skin: '',
      publicPage: {
        has: true,
        route: 'landingHelp'
      },
      hostPro: ['lms-help.golomtbank.local'],
      hostDev: ['192.168.42.2:8081', '192.168.0.105:80802', '192.168.0.100:80802', '192.168.1.5:80804'],
      fileUploadSize: {
        default: {
          size: 204800,
          msg: "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 200мб байна."
        },
        student: {
          size: 102400,
          msg: "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100мб байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      helpPageUrl: "https://lms-help.golomtbank.local",
      streamBaseUrl: 'https://lms-stream.golomtbank.local:8443/',
    },
    {
      id: 9245,
      name: "Нийгмийн даатгал",
      logo: "media/logo/ndaatgal.jpg",
      bgLogin: "assets/img/img15.png",
      skin: '',
      key: '7CuefISBZE6y1I2Zkt1XtQ',

      hostPro: ['ndaatgal.gosmart.mn', 'www.ndaatgal.gosmart.mn'],
      hostDev: ['192.168.0.105:8081', '192.168.0.100:80802', '192.168.42.2:8080', '192.168.1.5:808120'],
      register: true,
      fileUploadSize: {
        default: {
          size: 1048576,
          msg: "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 1гб байна."
        },
        student: {
          size: 102400,
          msg: "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100мб байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      helpPageUrl: "http://help.gosmart.mn",
      hasStreamServer: false,
      streamBaseUrl: 'https://stream-gate.gosmart.mn/',
      hubBaseUrl: 'https://ndaatgal.gosmart.mn/core/',
      baseUrl: 'https://ndaatgal.gosmart.mn/mobCore/',
    },
    {
      id: 9246,
      name: "Muren",
      logo: "https://res.gosmart.mn/media/icon.png",
      bgLogin: "assets/img/img15.png",
      skin: '',
      key: '8EnZS_dGbkipGzqRPPMsgA',

      hostPro: ['muren.gosmart.mn'],
      hostDev: ['192.168.0.105:8082', '192.168.0.100:808096'],
      register: true,
      fileUploadSize: {
        default: {
          size: 204800,
          msg: "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 200мб байна."
        },
        student: {
          size: 102400,
          msg: "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100мб байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      helpPageUrl: "http://help.gosmart.mn",
      streamBaseUrl: 'https://stream-gate.gosmart.mn/',
    },
    {
      id: 9247,
      name: "Монголын Үндэсний <br />Мал Эмнэлгийн Холбоо",
      logo: "media/logo/mvma.png",
      skin: 'is-mvma',
      logoFooter: "",
      publicPage: {
        has: true,
        route: 'landingPage'
      },
      key: 'IpHO1B8Q4EyqfNRuTJaTHg',
      hostPro: ['mvma.gosmart.mn', 'vet-edu.mn', 'www.vet-edu.mn'],
      hostDev: ['192.168.0.105:80801', '192.168.0.100:80801', '192.168.1.5:808120', '192.168.42.2:80808'],
      register: true,
      fileUploadSize: {
        default: {
          size: 204800,
          msg: "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 200мб байна."
        },
        student: {
          size: 102400,
          msg: "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100мб байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      helpPageUrl: "http://help.gosmart.mn",
      v2BaseUrl: "http://app.gosmart.mn",
      streamBaseUrl: 'https://stream-gate.gosmart.mn/',
    },
    {
      id: 9235,
      name: "Улаанбаатар төмөр зам",
      logo: "media/logo/ubtz-main.png",
      bgLogin: "assets/img/img15.png",
      skin: '',
      key: 'OorU4s35GE_30FR_ubbdwA',

      hostPro: ['my-railway.com', 'www.my-railway.com', 'railway.gosmart.mn'],
      hostDev: ['192.168.0.105:80801', '192.168.0.100:80801', '192.168.42.2:8081', '192.168.0.100:80803'],
      fileUploadSize: {
        default: {
          size: 1048576,
          msg: "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 1гб байна."
        },
        student: {
          size: 1,
          msg: "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 1kb байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      helpPageUrl: "http://help.gosmart.mn",
      streamBaseUrl: 'https://stream-gate.gosmart.mn/',
      hubBaseUrl: 'https://www.my-railway.com/core/',
      baseUrl: 'https://my-railway.com/mobCore/',
    },
    {
      id: 9132,
      name: "Соёл урлагийн их сургууль",
      logo: "media/logo/mnuac-mini.png",
      bgLogin: "assets/bg/mnuac.png",
      skin: '',
      key: 'xFo2zg983Esakr6rtQEu2Q',
      publicPage: {
        has: true,
        route: 'mnuac'
      },
      hostPro: ['open.mnuac.edu.mn', 'smart.mnuac.edu.mn'],
      hostDev: ['192.168.0.105:80801'],
      fileUploadSize: {
        default: {
          size: 1048576,
          msg: "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 1гб байна."
        },
        student: {
          size: 30720,
          msg: "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 30мб байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      helpPageUrl: "http://smart.mnuac.edu.mn",
      v2BaseUrl: "http://office.mnuac.edu.mn",
      streamBaseUrl: 'https://stream-gate.gosmart.mn/',
      hubBaseUrl: 'https://app.gosmart.mn/coreMNUAC/',
      baseUrl: 'https://mobcoremnuac.gosmart.mn/',
    },
    {
      id: 9251,
      name: "ГрэйпСити Монгол",
      logo: "media/logo/grapecity_mini.png",
      bgLogin: "assets/img/orgs/grapecity.png",
      skin: '',
      key: '125LWBl5OkSL0axKGzSIyQ',
      hostPro: ['grapecity.gosmart.mn'],
      hostDev: ['192.168.0.105:80801'],
      fileUploadSize: {
        default: {
          size: 1048576,
          msg: "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 1гб байна."
        },
        student: {
          size: 30720,
          msg: "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 30мб байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      register: true,
      helpPageUrl: "http://help.gosmart.mn",
      streamBaseUrl: 'https://stream-gate.gosmart.mn/',
    },
    {
      id: 9252,
      name: "ХХҮЕГ",
      logo: "media/logo/halamj.png",
      bgLogin: "assets/img/covid.svg",
      skin: '',
      key: '1KPU_UlFH0eSKjt2_SGn1g',
      hostPro: ['halamj.gosmart.mn'],
      hostDev: ['192.168.0.105:80801'],
      fileUploadSize: {
        default: {
          size: 2048000,
          msg: "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 2GB байна."
        },
        student: {
          size: 30720,
          msg: "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 30мб байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      //register: true,
      helpPageUrl: "http://help.gosmart.mn",
      streamBaseUrl: 'https://stream-gate.gosmart.mn/',
      hubBaseUrl: 'https://halamj.gosmart.mn/core/',
      baseUrl: 'https://halamj.gosmart.mn/mobCore/',
    },
    {
      id: 9254,
      name: "Удирдлагын академи",
      logo: "media/logo/noah.png",
      bgLogin: "assets/img/state.png",
      //bgLogin: "assets/img/mesp.png",
      skin: 'is-state',
      key: 'Ow9wnhp88kGyJbJHLeh1ww',
      hostPro: ['surgalt.gov.mn', 'state.gosmart.mn', 'academy.gosmart.mn', '192.168.0.105:701'],
      hostDev: ['192.168.0.105:80802', '192.168.0.105:701', '192.168.0.100:80801'],
      fileUploadSize: {
        default: {
          size: 1048576,
          msg: "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 1гб байна."
        },
        student: {
          size: 30720,
          msg: "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 30мб байна."
        }
      },
      publicPage: {
        has: true,
        route: 'landingPage'
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      register: true,
      helpPageUrl: "http://help.gosmart.mn",
      streamBaseUrl: 'https://stream-academy-ssl.gosmart.mn/',
      reportBaseUrl: 'https://academy-report.gosmart.mn/',
      PDFJS_URL: 'https://surgalt.gov.mn/pdfobject/web/viewer.html',
      cdnBaseUrl: 'https://academy-cdn.gosmart.mn/',
      hubBaseUrl: 'https://surgalt.gov.mn/core/',
      baseUrl: 'https://surgalt.gov.mn/mobCore/',
    },
    {
      id: 9256,
      name: "Training Hub",
      logo: "media/icon.png",
      bgLogin: "assets/img/covid.svg",
      skin: '',
      key: 'Sv_RD56LTEWyS_4krRvW6A',
      hostPro: ['traininghub.gosmart.mn'],
      hostDev: ['192.168.0.105:80801', '192.168.0.100:80801'],
      fileUploadSize: {
        default: {
          size: 1048576,
          msg: "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 1гб байна."
        },
        student: {
          size: 30720,
          msg: "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 30мб байна."
        }
      },
      publicPage: {
        has: false,
        route: 'landingPage'
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      register: true,
      helpPageUrl: "http://help.gosmart.mn",
      streamBaseUrl: 'https://stream-gate.gosmart.mn/',
    },
    {
      id: 9253,
      name: "Тээврийн автомашины дарааллын систем",
      logo: "media/logo/tads.png",
      skin: 'is-tads',
      logoFooter: "",
      publicPage: {
        has: false,
        route: 'landingTads'
      },
      key: 'aal8X8oVMkW9CVK0bwCS3g',
      hostPro: ['tads.gosmart.mn'],
      hostDev: ['192.168.0.105:80801', '192.168.0.100:80801', '192.168.1.5:8080', '192.168.42.2:80808'],
      //register: true,
      fileUploadSize: {
        default: {
          size: 5120,
          msg: "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 5мб байна."
        },
        student: {
          size: 102400,
          msg: "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100мб байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      helpPageUrl: "http://help.gosmart.mn",
      streamBaseUrl: 'https://stream-gate.gosmart.mn/',
    },
    {
      id: 100,
      name: "Зайн сургалтын систем",
      key: 'TXImUpThuPeVxcrt1QH3Ev',
      logo: "media/logo/mta.svg",
      bgLogin: "assets/img/covid.svg",
      hostPro: ['e-learning.mta.mn'],
      hostDev: ['192.168.0.105:80802', '192.168.42.2:80809'],
      fileUploadSize: {
        default: {
          size: 2048000,
          msg: "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 2GB байна."
        },
        student: {
          size: 2048000,
          msg: "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 2GB байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      register: false,
      helpPageUrl: "http://help.gosmart.mn",
      hasStreamServer: false,
      streamBaseUrl: 'https://stream-gate.gosmart.mn/',
      PDFJS_URL: 'https://cdn.mta.mn/pdfobject/web/viewer.html',
      hubBaseUrl: 'https://e-learning.mta.mn/core/',
      baseUrl: 'https://e-learning.mta.mn/mobCore/',
    },
    {
      id: 9257,
      name: "Болорболд",
      key: 'lD_H42EAqUG1OIxd96UNlw',
      logo: "media/logo/bolorbold.png",
      bgLogin: "assets/img/covid.svg",
      hostPro: ['bolorbold.gosmart.mn'],
      hostDev: ['192.168.1.10:80801', '192.168.42.2:80809'],
      fileUploadSize: {
        default: {
          size: 2048000,
          msg: "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 2GB байна."
        },
        student: {
          size: 102400,
          msg: "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100MB байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      register: true,
      helpPageUrl: "http://help.gosmart.mn",
      streamBaseUrl: 'https://stream-gate.gosmart.mn/',
    },
    {
      id: 9258,
      name: "RS2 Consulting",
      key: 'qfPEUNVov0STDXrAcyshxg',
      logo: "media/logo/rs2.jpg",
      bgLogin: "assets/img/covid.svg",
      hostPro: ['rs2.gosmart.mn'],
      hostDev: ['192.168.1.10:80801', '192.168.42.2:80809'],
      fileUploadSize: {
        default: {
          size: 2048000,
          msg: "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 2GB байна."
        },
        student: {
          size: 102400,
          msg: "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100MB байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      register: true,
      helpPageUrl: "http://help.gosmart.mn",
      streamBaseUrl: 'https://stream-gate.gosmart.mn/',
    },
    {
      id: 9259,
      name: "Орчлон сургууль",
      key: '22HVuYbPRk_ZHdD9yBr5dg',
      logo: "media/logo/orchlon.png",
      bgLogin: "assets/img/orchlon.png",
      skin: 'is-orchlon',
      hostPro: ['time.orchlon.mn', 'orchlon.gosmart.mn'],
      hostDev: ['192.168.0.105:80801', '192.168.42.2:80809'],
      fileUploadSize: {
        default: {
          size: 2048000,
          msg: "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 2GB байна."
        },
        student: {
          size: 102400,
          msg: "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100MB байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      register: true,
      helpPageUrl: "http://help.gosmart.mn",
      streamBaseUrl: 'https://stream-gate.gosmart.mn/',
    },
    {
      id: 9260,
      name: "НЭКСТ Групп",
      key: 'iR4il5S7u0eaX0F0Fi02rQ',
      logo: "media/logo/next.png",
      bgLogin: "assets/img/covid.svg",
      hostPro: ['next.gosmart.mn'],
      hostDev: ['192.168.0.105:80801', '192.168.42.2:80809'],
      fileUploadSize: {
        default: {
          size: 2048000,
          msg: "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 2GB байна."
        },
        student: {
          size: 102400,
          msg: "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100MB байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      register: true,
      helpPageUrl: "http://help.gosmart.mn",
      streamBaseUrl: 'https://stream-gate.gosmart.mn/',
    },
    {
      id: 9262,
      name: "Suld United LLC",
      key: 'PeqflMH8GEWkS2NkZYldTg',
      logo: "media/logo/nexus.png",
      bgLogin: "assets/img/nexus.jpg",
      hostPro: ['nexusauto.gosmart.mn'],
      hostDev: ['192.168.0.105:80801', '192.168.42.2:80809'],
      fileUploadSize: {
        default: {
          size: 2048000,
          msg: "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 2GB байна."
        },
        student: {
          size: 102400,
          msg: "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100MB байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      register: true,
      helpPageUrl: "http://help.gosmart.mn",
      streamBaseUrl: 'https://stream-gate.gosmart.mn/',
      baseUrl: 'https://mobcore.gosmart.mn/',
    },
  ],
  roleDefaultPages: [{
      id: 1,
      title: "Динамик Платформ",
      roles: [{
        icon: 'home',
        title: 'Эхлэл',
        role: ['officehome'],
        rawLink: '/wall',
      }, ]
    },
    {
      id: 2,
      title: "Сургалтын систем",
      roles: [{
          icon: 'database',
          title: 'Сургалтын админ',
          role: ['learningadmin'],
          rawLink: '/lms/admin/115/0/0',
        },
        {
          icon: 'book',
          title: 'Багш',
          role: ['learningteacher'],
          rawLink: '/lms/dashboard',
        },
        {
          icon: 'award',
          title: 'Суралцагч',
          role: ['learningstudent', 'learningoffice', 'learningteacher', 'learningadmin'],
          rawLink: '/lms/participant',
        },
        {
          icon: 'book-open',
          title: 'Номын санч',
          role: ['learnlibraryorder'],
          rawLink: '/lms/library/0/0/null/4',
        },
        {
          icon: 'activity',
          title: 'Хөрөнгө',
          role: ['asset'],
          rawLink: '/asset/dashboard',
        },
      ]
    },
    {
      id: 4,
      title: "Албан хэрэг хөтлөлт",
      roles: [{
          icon: 'file-text',
          title: 'Ирсэн бичгийн бүртгэл',
          version: 2,
          v2: {
            type: 1,
            name: 'inDocList',
            link: '/archive/inDocList',
          },
          role: ['archive', 'archiveadmin'],
          rawLink: '/archive/inDocList',
        },
        {
          icon: 'file-text',
          title: 'Явсан бичгийн бүртгэл',
          version: 2,
          v2: {
            type: 1,
            name: 'outDocList',
            link: '/archive/outDocList',
          },
          role: ['archive', 'archiveadmin'],
          rawLink: '/archive/outDocList',

        },

      ]
    },
    {
      id: 5,
      title: "Гишүүнчлэл",
      roles: [{
          icon: 'user-plus',
          title: 'Гишүүнчлэл',
          role: ['memberadmin', 'membermanager'],
          rawLink: '/member/list/390',
        },
        {
          icon: 'user-plus',
          title: 'Гишүүн хайх',
          role: ['memberdb'],
          version: 2,
          v2: {
            type: 1,
            name: 'memberDb',
            link: '/member/db',
          },
          rawLink: '/member/db',
        },
      ]
    },
    {
      id: 5,
      title: "ТАДС",
      roles: [{
        icon: 'user-plus',
        title: 'ТАДС Админ',
        role: ['tadsadmin'],
        rawLink: '/tadsadmin/sequence/512/0/0',
      }]
    }
  ]
};